// write the boiler plate code
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { sdSupportSearchBaseURL,corporateInfoURL } from '../../constants/index';
import {checkReplaceUrl} from '../../utils'
import axios from 'axios';


const initialState = {
	loading: false,
	error: '',
	categories: {},
    corporateInfo: ''
};


export const getCategorySelection = createAsyncThunk('categorySelectionSlice/getCategorySelection', async (query) => {
    try {
        return await axios.get(sdSupportSearchBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

export const getCorporateInformationFragment =createAsyncThunk('categorySelectionSlice/getCorporateInformationFragment', async () => {
    try {
        return await axios.get(corporateInfoURL , {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

const processHtmlImages = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");

    const images = doc.querySelectorAll("img[data-src]");
    images.forEach((img) => {
        const originalDataSrc = img.getAttribute("data-src");
        const processedUrl = checkReplaceUrl(originalDataSrc); 

        img.setAttribute("src", processedUrl); 
        img.removeAttribute("data-src"); 
    });

    return doc.body.innerHTML; // Return the modified HTML string
  };

const categorySelectionSlice = createSlice({
    name: 'categorySelectionSlice',
    initialState,
    reducers: {
        
    },
    extraReducers: (builder) => {
        builder.addCase(getCategorySelection.pending, (state) => {
            state.loading = true;
        })
        .addCase(getCategorySelection.fulfilled, (state, action) => {
            state.loading = false;
            state.categories = action.payload?.grouped_docs;
        })
        .addCase(getCategorySelection.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(getCorporateInformationFragment.pending, (state) => {
            state.loading = true;
        })
        .addCase(getCorporateInformationFragment.fulfilled, (state, action) => {
            state.loading = false;
            // const parser = new DOMParser();
            // const doc = parser.parseFromString(action.payload, 'text/html');
            // const images = doc.querySelectorAll("img");
        
            // const corporateInformationFragment = doc.querySelector('.cmp-container');
            state.corporateInfo = processHtmlImages(action.payload);
        })
        .addCase(getCorporateInformationFragment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export const { } = categorySelectionSlice.actions;

export default categorySelectionSlice.reducer;
